import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Item = ({ value, text }) => (
  <option value={value}>{text}</option>
);

const SelectInput = (props) => {
  const {
    name,
    groupName,
    inputId,
    selected,
    onChange,
    disabled,
    options,
    className,
  } = props;

  return (
    <select
      name={`${groupName}[${name}]`}
      className={classnames('custom-select', className)}
      value={selected}
      onChange={onChange}
      disabled={disabled}
      id={inputId}>
      {options.map((item) => <Item key={item.value} {...item} />)}
    </select>
  );
};

SelectInput.defaultProps = {
  name: '',
  groupName: 'parameters',
  selected: null,
  options: [],
  disabled: false,
  className: null,
  inputId: null,
};

SelectInput.propTypes = {
  inputId: PropTypes.string,
  name: PropTypes.string,
  groupName: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  })),
};

export default SelectInput;
